const FileReaders = (file: File, set: React.Dispatch<React.SetStateAction<string[]>>) => {
    const reader = new FileReader();

    if (file) {
        reader.readAsDataURL(file);
    }

    reader.onload = function () {
        if (reader.result) {
            set((prev: string[]) => [...prev, reader.result as string]);
        }
    };

    reader.onerror = function () {
        // console.log(reader.error);
    };
};

export default FileReaders;
